import type { AppTab } from '../types/tabs'
import type { Translation } from '../translations'

interface MobileNavProps {
    activeTab: AppTab
    onTabChange: (tab: AppTab) => void
    t: Translation
}

export function MobileNav({ activeTab, onTabChange, t }: MobileNavProps) {
    return (
        <nav className="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200 bg-white/90 backdrop-blur sm:hidden">
            <div className="mx-auto flex max-w-5xl gap-2 px-4 py-2 pb-[calc(env(safe-area-inset-bottom)+0.5rem)]">
                <button
                    type="button"
                    onClick={() => onTabChange('search')}
                    className={`flex-1 rounded-2xl px-4 py-3 text-sm font-semibold inline-flex items-center justify-center ${activeTab === 'search' ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700'}`}
                    aria-label={t.searchTab}
                    title={t.searchTab}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
                        <path d="M10 2a8 8 0 1 0 4.9 14.32l4.39 4.39 1.42-1.42-4.39-4.39A8 8 0 0 0 10 2zm0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12z" />
                    </svg>
                </button>
                <button
                    type="button"
                    onClick={() => onTabChange('chat')}
                    className={`flex-1 rounded-2xl px-4 py-3 text-sm font-semibold inline-flex items-center justify-center ${activeTab === 'chat' ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700'}`}
                    aria-label={t.chatTab}
                    title={t.chatTab}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
                        <path d="M4 4h16v12H7l-3 3V4zm2 2v9.17L6.17 15H18V6H6zm2 2h8v2H8V8zm0 4h6v2H8v-2z" />
                    </svg>
                </button>
            </div>
        </nav>
    )
}
